import Hls from 'hls.js';
import { RefObject, useEffect } from 'react';

const useHlsVideo = (
  videoUrl?: string,
  videoRef?: RefObject<HTMLVideoElement>,
): void => {
  useEffect(() => {
    if (!videoUrl) {
      return () => {};
    }

    const video = videoRef?.current;

    if (!video) {
      return () => {};
    }

    if (Hls.isSupported()) {
      const hls = new Hls({ startLevel: 4 });
      hls.loadSource(videoUrl);
      hls.attachMedia(video);

      return () => {
        hls.destroy();
      };
    }

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = videoUrl;
      return () => {};
    }

    return () => {};
  }, [videoRef, videoUrl]);
};

export default useHlsVideo;
